// @flow
import React from 'react';
import { colors } from 'seedling/constants';
import type { IconProps } from './types';

export type PrivateEyeIconProps = IconProps & { color: string, title: string };

const PrivateEyeIcon = ({
  width,
  height,
  className,
  color,
  title,
}: PrivateEyeIconProps) => (
  <svg
    className={className}
    width={width}
    height={height}
    viewBox="0 0 21 15"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>{title}</title>
    <g
      id="not_visible_privateeye"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g id="not_visible_privateeye16x16-copy">
        <path
          d="M11.68125,3.89333333 L6.890625,9.01333333 C6.72169854,8.56165344 6.63282694,8.08315749 6.628125,7.6 C6.63160005,6.5603495 7.04148227,5.56468341 7.76760097,4.83204 C8.49371967,4.09939658 9.47659408,3.68979109 10.5,3.69331055 C10.9019456,3.69296345 11.3011493,3.76055349 11.68125,3.89333333 L11.68125,3.89333333 Z"
          id="Path"
          fill={color}
        />
        <path
          d="M14.345625,7.6 C14.345625,9.7597599 12.6260014,11.5126539 10.5,11.52 L10.26375,11.52 L14.319375,7.18666667 C14.3325,7.30666667 14.345625,7.46666667 14.345625,7.6 Z"
          id="Path"
          fill={color}
        />
        <path
          d="M21,7.69333333 L20.50125,8.46666667 C19.55625,9.8 16.03875,14.2666667 10.4475,14.2666667 C9.61027549,14.2728912 8.77599611,14.1652693 7.966875,13.9466667 L9.279375,12.5333333 C9.66180146,12.5914133 10.0477193,12.6225986 10.434375,12.6266667 C15.0675,12.6266667 18.06,9.04 19.03125,7.70666667 C18.2879843,6.65053856 17.4046307,5.70380794 16.40625,4.89333333 L17.521875,3.69333333 C18.6455773,4.635154 19.631148,5.73514314 20.44875,6.96 L21,7.69333333 Z"
          id="Path"
          fill={color}
          fillRule="nonzero"
        />
        <path
          d="M13.899375,1.52 L12.6525,2.85333333 C11.9518871,2.65701417 11.2265229,2.56715101 10.5,2.58666667 C8.36187684,2.5990156 6.29374773,3.36214332 4.64625,4.74666667 C3.60490978,5.59513669 2.68981592,6.59211956 1.929375,7.70666667 C2.82723861,8.93238811 3.91291763,10.0037884 5.145,10.88 L4.01625,12.0666667 C2.65988976,11.0835277 1.47159117,9.88087154 0.49875,8.50666667 L0,7.74666667 L0.485625,6.97333333 C1.404375,5.56 4.80375,0.973333333 10.434375,0.933333333 C11.6150068,0.91150968 12.7895285,1.11037049 13.899375,1.52 Z"
          id="Path"
          fill={color}
          fillRule="nonzero"
        />
        <polygon
          id="Path"
          fill="#FFFFFF"
          fillRule="nonzero"
          points="8.806875 11.12 6.64125 13.4266667 6.628125 13.4133333"
        />
        <path d="M5.01375,14 L16.996875,1.2" id="Path" />
        <path
          d="M17.56125,1.76 L16.603125,2.77333333 L13.86,5.72 L8.806875,11.0533333 L8.806875,11.0533333 L6.64125,13.4266667 L5.59125,14.56 C5.43622263,14.7123564 5.22944282,14.7982908 5.01375,14.8001078 C4.80734773,14.8034983 4.60839663,14.7216923 4.4625,14.5733333 C4.31422332,14.4232252 4.230879,14.2193212 4.230879,14.0066667 C4.230879,13.7940122 4.31422332,13.5901082 4.4625,13.44 L4.83,13.0533333 L7.573125,10.12 L12.823125,4.49333333 L15.238125,1.90666667 L16.40625,0.653333333 C16.6008481,0.443737512 16.890735,0.355527725 17.1667132,0.421931746 C17.4426914,0.488335768 17.6628332,0.699265247 17.7442132,0.975265088 C17.8255933,1.25126493 17.7558481,1.55040419 17.56125,1.76 L17.56125,1.76 Z"
          id="Path"
          fill={color}
          fillRule="nonzero"
        />
      </g>
    </g>
  </svg>
);

PrivateEyeIcon.defaultProps = {
  color: colors.mediumGrey,
  width: 20,
  height: 20,
  title: 'Private',
};

export default PrivateEyeIcon;
